import React from 'react';
import './sec1-booking.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from '../components/common/cta';
import { useNavigate } from 'react-router-dom';
import Inputtext from '../components/common/input';
import { useLocation } from 'react-router-dom';
import SecCta from '../components/common/secondarycta';
import './sec1-booking3.css'
import pic32 from '../assets/pic32.png'
import pic33 from '../assets/pic33.png'
import Popup from '../components/common/popup';
import Errormsginput from '../components/common/errormsginput';


const Sec1bookingp3 = () => {


const location = useLocation();

const [bookingData, setBookingData] = useState(
  location.state || {
    ticket: null,
    quantity: 1,
    user: { name: "", email: "", phone: "", job_title: "", company_name: "", address: "" },
    date: new Date().toISOString(),
  }
);


 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);


const [showErrorPopup, setShowErrorPopup] = useState(false);
const [selectedPayment, setSelectedPayment] = useState("card");
const [agreed, setAgreed] = useState(false);

const [showPopup, setShowPopup] = useState(false);
const [popup, setPopup] = useState([]);

const closePopup = () => {
  setShowPopup(false);
};




const [paymentData, setPaymentData] = useState({
  cardName: "",
  cardNumber: "",
  expiry: "",
  cvv: ""
});


const [errors, setErrors] = useState({});
const [cardNameError, setCardNameError] = useState("");
const [cardNumberError, setCardNumberError] = useState("");
const [expiryError, setExpiryError] = useState("");
const [cvvError, setCvvError] = useState("");
const [agreedError, setAgreedError] = useState("");

const handleBooking = async () => {
  let hasError = false;

      if (!paymentData.cardName) { setCardNameError("Card name is required"); hasError = true; }
      else setCardNameError("");

      if (!paymentData.cardNumber) { setCardNumberError("Card number is required"); hasError = true; }
      else setCardNumberError("");

        if (!paymentData.expiry) { setExpiryError("Expiry is required"); hasError = true; }else setExpiryError("");

      if (!paymentData.cvv) { setCvvError("CVV is required"); hasError = true; }
      else setCvvError("");
      
        if (!agreed) { setAgreedError("You must agree to terms"); hasError = true; }
        else setAgreedError("");

        if (hasError) { setShowErrorPopup(true); return;}



 const price = bookingData.ticket?.price || 0;
  const subtotal = price * bookingData.quantity;
  const taxes = 200;
  const total = subtotal + taxes;

 const { data: userData, error: userError } = await supabase
    .from("users")
    .insert([{
      user_name: bookingData.user.name,
        user_email: bookingData.user.email,
      phone: bookingData.user.phone,
        job_title: bookingData.user.job_title,
      company_name: bookingData.user.company_name,
      address: bookingData.user.address,
    }])

    .select()
    .single();


  if (userError) {
    console.error(userError);
    alert("Error");
    return; 
  }

 const { error: bookingError } = await supabase
    .from("bookings")
    .insert([{
      user_id: userData.id,
      ticket_id: bookingData.ticket.id,
         booking_date: bookingData.date,
        event_id: bookingData.eventId,
      quantity: bookingData.quantity,
      total_price: total,
      status: "pending"
    }]);


    
        if (bookingError) {
    console.error(bookingError);
    alert("Error creating booking");
    return; 
  }

setShowPopup(true);


}

useEffect(() => {
const getpopup = async()=>{
    const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });;

setPopup(res.data);
}
getpopup();
}, []);




const navigate = useNavigate();


    return (  
    <section  className='sec1-booking '>
            <h1 className='header-section'>{content?.[32]?.header}</h1>
            <nav className='container-booking-points'>
                <nav className='line-points-booking'>
                      <button className='normal-circle' onClick={() => navigate('/booking', { state: bookingData })}></button>       
                      <button className='normal-circle' onClick={() => navigate('/booking-summary', { state: bookingData })}></button>  
                      <button className='activecircle'></button>    
                </nav>
            </nav>


<fieldset className='container-forms-booking'>
            <form className='form-booking'>
                <h2 className='subheadr-booking'>{content?.[32]?.sub_title}</h2>
<section className='container-cards-selection-sec5-p3'>

                                                        <button
                                                        className={`button-card-sec5-p3 ${selectedPayment === "card" ? "active" : ""}`}
                                                        onClick={(e) => {
                                                        e.preventDefault();
                                                        setSelectedPayment("card");
                                                        }}
                                                        >
                                                            <img src={pic32} alt='credit card'></img>
                                                            <h3 className='card-text-sec5-p3'>Credit Card</h3>
                                                        </button>

                                                        <button
                                                        className={`button-card-sec5-p3 ${selectedPayment === "paypal" ? "active" : ""}`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedPayment("paypal");
                                                            }}
                                                        
                                                        >
                                                            <img src={pic33} alt='paypal'></img>
                                                            <h3 className='card-text-sec5-p3'>Paypal</h3>
                                                        </button>

                                                    </section>
            </form>


            <form className='form-booking'>
                <h2 className='subheadr-booking'>{content?.[32]?.sub_title2}</h2>
                <fieldset className='container-inputs-form-booking'>
                    <Inputtext id='Card Placeholder'  label='Card Placeholder' placeholder='Enter placeholder'
                      value={paymentData.cardName}   
                              onChange={(e) =>
                                  setPaymentData(prev => ({
                                 ...prev,
                                 cardName: e.target.value
                                  }))
                                                                }/>
                      <Errormsginput message={cardNameError} />

                    <Inputtext id='Card Number'  label='Card Number' placeholder='Enter Number'
                    value={paymentData.cardNumber} 
                      onChange={(e) =>
                                 setPaymentData(prev => ({
                                  ...prev,
                             cardNumber: e.target.value
                                  }))
                                   } />
                        <Errormsginput message={cardNumberError} />

                         <Inputtext id='Expire Date'  label='Expire Date' placeholder='MM/YY'
                        value={paymentData.expiry}   
                          onChange={(e) =>
                                 setPaymentData(prev => ({
                                 ...prev,
                                expiry: e.target.value
                                 }))
                                 } />
                          <Errormsginput message={expiryError} />



                         <Inputtext id='CVV'  label='CVV' placeholder='Enter CVV'
                         value={paymentData.cvv}  
                          onChange={(e) =>
                               setPaymentData(prev => ({
                                ...prev,
                                 cvv: e.target.value
                                  }))
                                } />
                                <Errormsginput message={cvvError} />



 <label className="custom-checkbox" onChange={(e) => setAgreed(e.target.checked)}>
                                                            <input type="checkbox"  />
                                                            <span className="checkmark"></span>
                                                            I agree to the terms
                                                            </label>
                                                            <Errormsginput message={agreedError} />



                </fieldset>
                
            </form>

                        {showPopup && (
  <Popup
    to="/home"
    onClose={closePopup}
    img={popup?.[1]?.image}
     alt={popup?.[1]?.icon_alt} 
    header={popup?.[1]?.title}
    para={popup?.[1]?.paragraph}
    title={popup?.[1]?.cta_text_primary}
  />
)}


{showErrorPopup && (
  <Popup
    to="/booking-card-pay"
    onClose={() => setShowErrorPopup(false)}
    img={popup?.[3]?.image}
    alt={popup?.[3]?.icon_alt}
    header={popup?.[3]?.title}
    para={popup?.[3]?.paragraph}
    title={popup?.[3]?.cta_text_primary}
  />
)}





    </fieldset>

            <button className='CONTAINER-CTAA-BOOKING-PAGE2'>
                        <SecCta title={content?.[32]?.cta} onClick={() => navigate('/booking-summary', { state: bookingData })} />

                         <Cta title={content?.[32]?.cta2} onClick={handleBooking} />
            </button>
    </section>);
}
 
export default Sec1bookingp3;